<template>
  <v-dialog v-model="showStatsDialog" max-width="500" content-class="rounded-lg">
    <v-card>
      <v-card-title>
        <v-icon class="mr-2">mdi-database</v-icon>
        Estatísticas do App
      </v-card-title>

      <v-card-text>
        <div v-if="cacheStats">
          <p class="mb-0 d-flex gap-2 align-center" >
            <strong>Versão:</strong>
            <v-chip small label class="px-2">{{ currentVersion ? currentVersion.substring(0, 8) : "N/A" }}</v-chip>
          </p>

          <v-divider class="my-3"></v-divider>

          <p class="mb-2 font-weight-bold">Caches ativos:</p>
          <div v-if="Object.keys(cacheStats).length > 0">
            <div
              v-for="(count, name) in cacheStats"
              :key="name"
              class="d-flex justify-space-between align-center mb-1"
            >
              <span class="text-caption">{{ name }}</span>
              <v-chip small color="primary">{{ count }} itens</v-chip>
            </div>
          </div>
          <p v-else class="text-caption text--secondary">Nenhum cache ativo</p>
        </div>
        <div v-else>
          <v-progress-circular indeterminate></v-progress-circular>
          Carregando estatísticas...
        </div>
      </v-card-text>

      <v-card-actions>
        <v-btn
          color="warning"
          text
          @click="clearAllCache"
          :loading="clearingCache"
          small
        >
          <v-icon small class="mr-1">mdi-delete</v-icon>
          Limpar Cache
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn text @click="showStatsDialog = false">Fechar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "VersionDetails",
  data() {
    return {
      showStatsDialog: false,
      clearingCache: false,
      currentVersion: null,
      cacheStats: null,
    };
  },
  methods: {
    onSWMessage(event) {
      const { data } = event;

      switch (data.type) {
        case "VERSION_INFO":
          this.currentVersion = data.currentVersion;
          this.cacheStats = data.cacheStats;
          break;

        case "CACHE_CLEARED":
          this.clearingCache = false;
          this.requestCacheStats();
          break;
      }
    },
    open() {
      this.requestCacheStats();
      this.showStatsDialog = true;
    },
    async showCacheStats() {
      this.showStatsDialog = true;
      await this.requestCacheStats();
    },

    async requestCacheStats() {
      if (navigator.serviceWorker.controller) {
        navigator.serviceWorker.controller.postMessage({
          type: "CHECK_VERSION",
        });
      }
    },
    async clearAllCache() {
      if (!navigator.serviceWorker.controller) return;

      this.clearingCache = true;
      navigator.serviceWorker.controller.postMessage({
        type: "FORCE_UPDATE",
      });
    },
  },
  mounted() {
    this.$root.$on("showCacheStats", this.showCacheStats);
    if ("serviceWorker" in navigator) {
      navigator.serviceWorker.addEventListener("message", this.onSWMessage);
    }
  },
  beforeDestroy() {
    this.$root.$off("showCacheStats", this.showCacheStats);
    if ("serviceWorker" in navigator) {
      navigator.serviceWorker.removeEventListener("message", this.onSWMessage);
    }
  },
};
</script>
